<template>
    <v-overlay :value="isInMaintenance" :z-index="999" opacity="0.95">
        <v-container class="text-center">
            <v-icon size="120" color="warning" class="mb-6">mdi-wrench-clock</v-icon>
            <h1 class="text-h4 white--text mb-4">Sistema in Manutenzione</h1>
            <p class="text-body-1 white--text mb-6" style="max-width: 500px">
                {{ maintenanceMessage }}
            </p>
            <v-btn
                color="primary"
                large
                @click="checkStatus"
                :loading="checking"
                :disabled="countdown > 0"
            >
                <v-icon left>mdi-refresh</v-icon>
                <span v-if="countdown > 0">Riprova tra {{ countdown }}s</span>
                <span v-else>Riprova</span>
            </v-btn>
        </v-container>
    </v-overlay>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    name: 'MaintenanceOverlay',

    data: () => ({
        checking: false,
        countdown: 0,
        timer: null
    }),

    computed: {
        ...mapGetters(['maintenanceMode', 'isInMaintenance']),
        maintenanceMessage() {
            return this.maintenanceMode.message || 'Stiamo effettuando aggiornamenti. Riprova tra qualche minuto.'
        }
    },

    watch: {
        isInMaintenance(val) {
            if (!val) {
                this.stopTimer()
                this.countdown = 0
            }
        }
    },

    methods: {
        startCountdown() {
            this.countdown = 60
            this.stopTimer()
            this.timer = setInterval(() => {
                if (this.countdown > 0) {
                    this.countdown--
                } else {
                    this.stopTimer()
                }
            }, 1000)
        },

        stopTimer() {
            if (this.timer) {
                clearInterval(this.timer)
                this.timer = null
            }
        },

        async checkStatus() {
            if (this.countdown > 0) return

            this.checking = true
            try {
                const response = await this.axios.get('maintenance-status')
                if (!response.data.maintenance) {
                    this.$store.commit('clearMaintenanceMode')
                    window.location.reload()
                } else {
                    // Ancora in manutenzione, avvia il countdown
                    this.startCountdown()
                }
            } catch (error) {
                // Se errore diverso da 503, potrebbe essere finita
                if (error.response && error.response.status !== 503) {
                    this.$store.commit('clearMaintenanceMode')
                    window.location.reload()
                } else {
                    // Ancora 503, avvia il countdown
                    this.startCountdown()
                }
            } finally {
                this.checking = false
            }
        }
    },

    beforeDestroy() {
        this.stopTimer()
    }
}
</script>
